import React from "react";

import { srcsetImage } from "../helpers";

class ProjectContentSection extends React.Component {
  constructor() {
    super();
    this.makeTheHTML = this.makeTheHTML.bind(this);
  }

  // Build out the section innerHTML, depending on the content type
  makeTheHTML(details) {
    const type = details.type;

    // Build out class CSS
    var theSectionClasses = ["workContent", `workContent--${type}`];
    var theInnerHTML = [];
    var inlineStyle = {};

    // Universal options
    if (details.isHero) {
      theSectionClasses.push("workContent--heroSection");
      inlineStyle = details.heroBGColor ? { backgroundColor: details.heroBGColor } : {};
    }

    if (details.padding) {
      if (details.padding.length === 1) {
        theSectionClasses.push(`padding--${details.padding[0]}`);
      } else {
        theSectionClasses.push(`padding--${details.padding[0]}`);
        theSectionClasses.push(`padding__bottom--${details.padding[1]}`);
      }
    } else if (details.isHero) {
      theSectionClasses.push("padding--6");
    }

    if (details.caption) {
      var captionContainerClasses = [
        "workContent--caption--container",
        "workContent--images--caption--container",
      ];

      if (details.isHero) {
        captionContainerClasses.push("workContent--images--caption--container__heroCaption");
      }

      if (details.captionColor) {
        var captionStyle = { color: details.captionColor };
      }

      var theCaptionHTML = (
        <section
          className={captionContainerClasses.join(" ")}
          dangerouslySetInnerHTML={{ __html: details.caption }}
        />
      );

      theSectionClasses.push("workContent--images__hasCaption");
    } else {
      theCaptionHTML = null;
    }

    if (details.padding) {
      if (details.padding.length === 1) {
        theSectionClasses.push(`padding--${details.padding[0]}`);
      } else {
        theSectionClasses.push(`padding--${details.padding[0]}`);
        theSectionClasses.push(`padding__bottom--${details.padding[1]}`);
      }
    } else if (details.isHero) {
      theSectionClasses.push("padding--6");
    }

    // Types
    if (type === "bigThumbnail") {
      theSectionClasses.push("workContent--bigThumbnail");

      theInnerHTML = (
        <section className="content--container">
          <figure>
            {srcsetImage(details.image, `${this.props.projectTitle} large thumbnail`)}
          </figure>
        </section>
      );
    } // end big thumbnail type
    else if (type === "code") {
      theInnerHTML = <div dangerouslySetInnerHTML={{ __html: details.code }} />;
    } // end code type
    else if (type === "images") {
      const numImages = details.files.length;
      const isHero = details.isHero ? details.isHero : false;

      theSectionClasses.push(`workContent--images__${numImages}images`);

      if (details.alignment) {
        theSectionClasses.push(`align-${details.alignment}`);
      }

      if (isHero) {
        theSectionClasses.push("workContent--heroSection");
        inlineStyle = details.heroBGColor ? { backgroundColor: details.heroBGColor } : {};
      }

      if (details.layout) {
        theSectionClasses.push(`workContent--images__layout-${details.layout}`);

        if (details.layout === "1x2" || details.layout === "2x1") {
          theSectionClasses.push(`workContent--images__layout-splitImages`);
        }
      }

      if (!details.hasOwnProperty("nonResponsive")) {
        theSectionClasses.push("workContent--images__responsive");
      } else {
        theSectionClasses.push("workContent--images__nonResponsive");
      }

      if (details.hasOwnProperty("layout")) {
        if (details.layout === "1x2" || details.layout === "2x1") {
          var isSplitImages = true;
        }
      }

      if (details.hasOwnProperty("layout") && details.layout !== "1x2") {
        var numberOfRows = parseInt(details.layout.charAt(2), 10);
      } else {
        numberOfRows = 1;
      }

      let imagesPerRow = numImages / numberOfRows;
      var imageRows = [];

      for (var i = 0; i < numberOfRows; i++) {
        let imageRow = details.files.slice(i * imagesPerRow, (i + 1) * imagesPerRow);

        imageRows.push(imageRow);
      }

      theInnerHTML = (
        <section className="content--container content--container__images">
          {imageRows.map((e, i) => {
            return (
              <div key={i} className="row images--row">
                {imageRows[i].map((e, ii) => {
                  let currentFile = imageRows[i][ii];
                  let imageFigCaption = currentFile.caption ? (
                    <figcaption style={captionStyle}>{currentFile.caption}</figcaption>
                  ) : null;
                  let imageColumns = currentFile.c ? currentFile.c : 12;
                  let theImage;
                  let theFigureClasses = [];
                  let theVideoClasses = [];
                  let theImgClasses = [];

                  if (isSplitImages) {
                    theVideoClasses.push(`splitImages--graphic`);
                    theVideoClasses.push(`splitImages--graphic__${ii + 1}`);

                    // We need to use the height of the two smaller graphics to set the
                    // height of the container to the cumulative height so that the excess is hidden
                    // on the tall graphic.
                    if (
                      (details.layout === "1x2" && ii !== 0) ||
                      (details.layout === "2x1" && ii !== 2)
                    ) {
                      theFigureClasses.push(`js-splitImages--heightCheck`);
                      theVideoClasses.push(`js-splitImages--heightCheck`);
                    }
                  }

                  if (currentFile.isVideo) {
                    // video filetypes (mp4)
                    theVideoClasses.push("video--animation");

                    return (
                      <video
                        loop={currentFile.loops ? true : false}
                        maxwidth={currentFile.width}
                        maxheight={currentFile.height}
                        className={theVideoClasses.join(" ")}
                        key={ii}
                        muted
                        playsInline
                        src={currentFile.url}
                      />
                    );
                  } else {
                    // image filetypes (jpg, svg, gif, png)
                    if (currentFile.dropShadow) {
                      theFigureClasses.push("image__dropShadow");
                    }

                    if (currentFile.isAnimated) {
                      theImgClasses.push("image__animatedGif");
                    }

                    if (currentFile.limitHeight) {
                      theImgClasses.push("image__limitHeight");
                    }

                    if (isSplitImages) {
                      theFigureClasses.push(`splitImages--graphic`);
                      theFigureClasses.push(`splitImages--graphic__${ii + 1}`);
                    }

                    if (this.props.isMobile && currentFile.mobileVersion) {
                      theImage = srcsetImage(
                        currentFile.mobileVersion,
                        null,
                        imageColumns,
                        theImgClasses
                      );
                    } else {
                      theImage = srcsetImage(
                        currentFile.imageData,
                        null,
                        imageColumns,
                        theImgClasses
                      );
                    }

                    return (
                      <figure
                        className={theFigureClasses.length > 0 ? theFigureClasses.join(" ") : null}
                        key={ii}
                      >
                        {theImage}
                        {imageFigCaption}
                      </figure>
                    );
                  }
                })}
              </div>
            );
          })}
        </section>
      );
    } // end image type
    else if (type === "quote") {
      theSectionClasses.push("workContent--quote");
      var inlineTextStyle = {};

      if (details.isHero && details.textColor) {
        inlineTextStyle["color"] = details.textColor;
      }

      theInnerHTML = (
        <section className="content--container">
          <blockquote key={theInnerHTML.length}>
            <span style={inlineTextStyle} className="workContent--quote--copy">
              {details.text}
            </span>
            <footer style={inlineTextStyle} className="workContent--quote--author">
              {details.author}
            </footer>
          </blockquote>
        </section>
      );
    } // end quote type
    else if (type === "spacer") {
      theSectionClasses.push("workContent--spacer");
      theSectionClasses.push(`workContent--spacer__${details.units}`);
      theInnerHTML = <div className="spacers" />;
      var spacers = [];

      for (var iii = details.units; iii > 0; iii--) {
        spacers.push(<span key={iii} className="spacer" />);
      }

      theInnerHTML = <div className="spacers">{spacers}</div>;
    } // end text type
    else if (type === "text") {
      theSectionClasses.push("workContent--text");

      theInnerHTML = (
        <section className="content--container">
          <div key={theInnerHTML.length} dangerouslySetInnerHTML={{ __html: details.content }} />
        </section>
      );
    } // end text type
    else if (type === "video") {
      theSectionClasses.push("workContent--video");
      var videoURL = details.url;

      if (videoURL.indexOf("vimeo") >= 0) {
        let videoCode = videoURL.split("/").pop();

        theInnerHTML = (
          <section className="content--container">
            <section className="video--container">
              <iframe
                src={`https://player.vimeo.com/video/${videoCode}`}
                frameBorder="0"
                webkitAllowFullScreen
                mozallowfullscreen
                allowFullScreen
              />
            </section>
            <section className="workContent--video--caption--container">
              <p>{details.credit}</p>
            </section>
          </section>
        );
      }
    }

    return (
      <section style={inlineStyle} className={theSectionClasses.join(" ")}>
        {theInnerHTML}
        {theCaptionHTML}
      </section>
    );
  }

  render() {
    const { details } = this.props;

    return this.makeTheHTML(details);
  }
}

export default ProjectContentSection;



/** WEBPACK FOOTER **
 ** ./src/components/ProjectContentSection.js
 **/